export enum PageTab {
  Active = 'active',
  Archived = 'archived'
}
